import { render, staticRenderFns } from "./ed-content-subject-calendar.component.vue?vue&type=template&id=b8c9a5d4&scoped=true&"
import script from "./ed-content-subject-calendar.component.ts?vue&type=script&lang=ts&"
export * from "./ed-content-subject-calendar.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-content-subject-calendar.component.scss?vue&type=style&index=0&id=b8c9a5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c9a5d4",
  null
  
)

export default component.exports